import Form from "./Form";
import useBoatType from "./hooks/useBoatType";

export const BoatType: React.FC = () => {
  const props = useBoatType();
  return <Form {...props} />;
};

export default BoatType;
